import React, { Component } from 'react';
import PhotoSphereViewer from 'photo-sphere-viewer';
import PanoTop from '../assets/images/py.jpg';
import PanoBack from '../assets/images/pz.jpg';
import PanoFront from '../assets/images/nz.jpg';
import PanoBottom from '../assets/images/ny.jpg';
import PanoLeft from '../assets/images/px.jpg';
import PanoRight from '../assets/images/nx.jpg';
import { withRouter } from 'react-router-dom';
import Hall360Cursor from '../molecules/Hall360Cursor';
import Hall360Intro from '../molecules/Hall360Intro';
import { walls } from '../data/walls';

let markerHtml = '<div class="btn-pulse"><div class="ring"></div><div class="circle"></div></div>';

class Hall360 extends Component {

  constructor( props ) {
    super( props );
    this.state = {
      mousePos: [ '50%', '50%' ],
      overMarker: false,
      panoReady: false,
    }
  }

  componentDidMount() {

    let viewer = new PhotoSphereViewer( {
      container: 'viewer',
      panorama: {
        left: PanoLeft,
        front: PanoFront,
        right: PanoRight,
        back: PanoBack,
        top: PanoTop,
        bottom: PanoBottom
      },
      time_anim: 1500,
      anim_speed: '3dps',
      navbar: false,
      min_fov: 20,
      max_fov: 90,
      default_fov: 60,
      markers: [
        {
          id: 1,
          wallId: 1,
          html: markerHtml,
          longitude: 0.48,
          latitude: 0.05,
          className: 'circleMarker',
        },
        {
          id: '1B',
          delegateMarkerId: 1,
          wallId: 1,
          html: `<p><span class="title">Place names</span><span>${walls[0].start} &mdash; ${walls[0].end}</span></p>`,
          longitude: 0.48,
          latitude: 0.25,
          className: 'textMarker',
        },
        {
          id: 2,
          wallId: 2,
          html: markerHtml,
          longitude: 0.96,
          latitude: 0.05,
          className: 'circleMarker',
        },
        {
          id: '2B',
          delegateMarkerId: 2,
          wallId: 2,
          html: `<p><span class="title">Place names</span><span>${walls[1].start} &mdash; ${walls[1].end}</span></p>`,
          longitude: 0.96,
          latitude: 0.25,
          className: 'textMarker',
        },
        {
          id: 3,
          wallId: 3,
          html: markerHtml,
          longitude: 2.04,
          latitude: 0.05,
          className: 'circleMarker',
        },
        {
          id: '3B',
          delegateMarkerId: 3,
          wallId: 3,
          html: `<p><span class="title">Place names</span><span>${walls[2].start} &mdash; ${walls[2].end}</span></p>`,
          longitude: 2.04,
          latitude: 0.25,
          className: 'textMarker',
        },
        {
          id: 4,
          wallId: 4,
          html: markerHtml,
          longitude: 2.53,
          latitude: 0.05,
          className: 'circleMarker',
        },
        {
          id: '4B',
          delegateMarkerId: 4,
          wallId: 4,
          html: `<p><span class="title">Place names</span><span>${walls[3].start} &mdash; ${walls[3].end}</span></p>`,
          longitude: 2.53,
          latitude: 0.25,
          className: 'textMarker',
        },
        {
          id: 5,
          wallId: 5,
          html: markerHtml,
          longitude: 3.62,
          latitude: 0.05,
          className: 'circleMarker',
        },
        {
          id: '5B',
          delegateMarkerId: 5,
          wallId: 5,
          html: `<p><span class="title">Place names</span><span>${walls[4].start} &mdash; ${walls[4].end}</span></p>`,
          longitude: 3.62,
          latitude: 0.25,
          className: 'textMarker',
        },
        {
          id: 6,
          wallId: 6,
          html: markerHtml,
          longitude: 4.11,
          latitude: 0.05,
          className: 'circleMarker',
        },
        {
          id: '6B',
          delegateMarkerId: 6,
          wallId: 6,
          html: `<p><span class="title">Place names</span><span>${walls[5].start} &mdash; ${walls[5].end}</span></p>`,
          longitude: 4.11,
          latitude: 0.25,
          className: 'textMarker',
        },
        {
          id: 7,
          wallId: 7,
          html: markerHtml,
          longitude: 5.20,
          latitude: 0.05,
          className: 'circleMarker',
        },
        {
          id: '7B',
          delegateMarkerId: 7,
          wallId: 7,
          html: `<p><span class="title">Place names</span><span>${walls[6].start} &mdash; ${walls[6].end}</span></p>`,
          longitude: 5.20,
          latitude: 0.25,
          className: 'textMarker',
        },
        {
          id: 8,
          wallId: 8,
          html: markerHtml,
          longitude: 5.68,
          latitude: 0.05,
          className: 'circleMarker',
        },
        {
          id: '8B',
          delegateMarkerId: 8,
          wallId: 8,
          html: `<p><span class="title">Place names</span><span>${walls[7].start} &mdash; ${walls[7].end}</span></p>`,
          longitude: 5.68,
          latitude: 0.25,
          className: 'textMarker',
        },
        {
          id: 9,
          wallId: 9,
          html: markerHtml,
          longitude: 6.22,
          latitude: -0.4,
          className: 'circleMarker',
        },
        {
          id: '9B',
          delegateMarkerId: 9,
          wallId: 9,
          html: `<p><span class="title">Military sites: Colonial Wars to Peacekeeping Operations</span><span>${walls[8].start} &mdash; ${walls[8].end}</span></p>`,
          longitude: 6.22,
          latitude: -0.3,
          className: 'textMarker',
        },
        {
          id: 10,
          wallId: 9,
          html: markerHtml,
          longitude: 1.49,
          latitude: -0.4,
          className: 'circleMarker',
        },
        {
          id: '10B',
          delegateMarkerId: 10,
          wallId: 9,
          html: `<p><span class="title">Military sites: Colonial Wars to Peacekeeping Operations</span><span>${walls[8].start} &mdash; ${walls[8].end}</span></p>`,
          longitude: 1.49,
          latitude: -0.3,
          className: 'textMarker',
        },
        {
          id: 11,
          wallId: 9,
          html: markerHtml,
          longitude: 3.1,
          latitude: -0.42,
          className: 'circleMarker',
        },
        {
          id: '11B',
          delegateMarkerId: 11,
          wallId: 9,
          html: `<p><span class="title">Military sites: Colonial Wars to Peacekeeping Operations</span><span>${walls[8].start} &mdash; ${walls[8].end}</span></p>`,
          longitude: 3.1,
          latitude: -0.32,
          className: 'textMarker',
        },
        {
          id: 12,
          wallId: 9,
          html: markerHtml,
          longitude: 4.65,
          latitude: -0.42,
          className: 'circleMarker',
        },
        {
          id: '12B',
          delegateMarkerId: 12,
          wallId: 9,
          html: `<p><span class="title">Military sites: Colonial Wars to Peacekeeping Operations</span><span>${walls[8].start} &mdash; ${walls[8].end}</span></p>`,
          longitude: 4.65,
          latitude: -0.32,
          className: 'textMarker',
        },
      ]
    } );

    viewer.on( 'select-marker', ( marker ) => {
      if (!marker.wallId) {
        return;
      }
      let wallId = marker.wallId;
      this.clickMarkerHandler( wallId );
      const clickedMarker = (
        marker.hasOwnProperty('delegateMarkerId') ?
        viewer.config.markers.filter((i) => i.id === marker.delegateMarkerId)[0] :
        marker
      );
      if (!clickedMarker) {
        return;
      }
      let options = {
        latitude: clickedMarker.latitude,
        longitude: clickedMarker.longitude - 0.3,
      };
      if ( viewer.getZoomLevel() !== 60 ) { options.zoom = 60}
      viewer.animate( options, 500 );
    } );

    viewer.on( 'over-marker', ( marker ) => {
      if ( marker.id > 0 && marker.id < 13 ) {
        this.overMarkerHandler(marker.id);
      }
    } );

    viewer.on( 'leave-marker', ( marker ) => {
      this.leaveMarkerHandler();
    } );

    viewer.on( 'ready', () => {
      this.readyHandler();
    });
  }

  clickMarkerHandler = ( id ) => {
    this.props.history.push( "wall?wall=" + id );
  };

  overMarkerHandler = (id) => {
    this.setState( {
      overMarker: id,
    } )
  };

  leaveMarkerHandler = () => {
    this.setState( {
      overMarker: false,
    } )
  };

  mouseMoveHandler = ( e ) => {
    this.setState( {
      mousePos: [ e.clientX + 'px', e.clientY + 'px' ],
    } )
  };

  readyHandler = () => {
    this.setState( {
      panoReady: true,
    } )
  };

  render() {
    return (
      <div className="Hall360" onMouseMove={( e ) => {this.mouseMoveHandler( e )}}>
        <div id="viewer"/>
        <Hall360Cursor overMarker={this.state.overMarker} mousePos={this.state.mousePos}/>
        <Hall360Intro ready={this.state.panoReady}/>
      </div>
    )
  }
}

export default withRouter( Hall360 );